import ScreenKey from '@/Enums/Screens/ScreenKey.enum';

export const SCREENS_WITH_READ_ONLY_ACCESS_OPTION = [
  ScreenKey.ADVERTISERS,
  ScreenKey.CAMPAIGN_MANAGEMENT,
  ScreenKey.PIXELS,
  ScreenKey.AGENCIES,
  ScreenKey.CREATIVE_LIBRARY,
  ScreenKey.SEGMENTS,
];
